<template>
  <pp-app
    v-if="!isLoading"
    :class="{'is-mobile': isMobile}"
    :style="cssVars"
    data-iframe-width
  >
    <router-view />
  </pp-app>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { WebToTextConstants } from '@/constants'

export default {
  name: 'App',
  data () {
    return {
      isLoading: true,
      backgroundColorOverride: '',
      textColorOverride: ''
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile',
      parentHeight: 'parentHeight',
      parentWidth: 'parentWidth',
      customSettings: 'customSettings'
    }),
    cssVars () {
      let cssVars = ''
      cssVars += this.parentWidth ? `--pp-parent-width:${this.parentWidth}px;` : ''
      cssVars += this.parentHeight ? `--pp-parent-height:${this.parentHeight}px;` : ''
      cssVars += `--pp-theme-color:${this.backgroundColor};`
      cssVars += `--pp-primary-button-hover-bg:${this.backgroundColor};`
      cssVars += `--pp-primary-button-text-custom-color:${this.textColor};`
      cssVars += `--pp-primary-disabled-button-color:${this.textColor};`
      return cssVars
    },
    backgroundColor () {
      return this.backgroundColorOverride || this.customSettings.colorPrimary || WebToTextConstants.DEFAULT_BACKGROUND_COLOR
    },
    textColor () {
      return this.textColorOverride || this.customSettings.colorText || WebToTextConstants.DEFAULT_TEXT_COLOR
    }
  },
  mounted () {
    // when iframe resizer has loaded
    window.iFrameResizer = {
      onReady: () => {
        // watch the page info and update in state the parent frame sizes
        // (used for determining mobile view)
        window.parentIFrame.getPageInfo((pageInfo) => {
          this.setParentSizeInfo(pageInfo)
        })
      }
    }
    // listen for parent window events
    window.addEventListener('message', this.eventHandler.bind(this))

    this.getCustomWidgetSettings({ practiceUuid: this.$practiceUuid, slug: WebToTextConstants.FEATURE_SLUG })
      .catch((e) => {
        this.trackGA({
          category: 'api-error',
          action: 'custom-widget-settings'
        })
      })
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    ...mapActions({
      getCustomWidgetSettings: 'getCustomWidgetSettings'
    }),
    ...mapMutations({
      setParentSizeInfo: 'SET_PARENT_SIZE_INFO'
    }),
    eventHandler (data = {}) {
      const { data: { type, payload: { widgetId, backgroundColor, textColor } = {} } } = data

      if (type === WebToTextConstants.WIDGET_SHOW_EVENT && widgetId === WebToTextConstants.WIDGET_ID) {
        this.backgroundColorOverride = backgroundColor
        this.textColorOverride = textColor

        this.trackGA({
          category: 'multi-channel-event',
          action: 'widget-open'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pp-app {
  --pp-primary-disabled-button-bg: #{$color-synapse-2};

  display: inline-block;
}
</style>
